module.exports = {
  data() {
    return {
      css: {
        table: {
          tableClass: "table",
          ascendingIcon: "mdi mdi-chevron-up",
          descendingIcon: "mdi mdi-chevron-down"
        }
      }
    };
  }
};